import QuoteStep from "../enums/QuoteStep";
import useAppStateStore from "../../../shared/store/AppStateStore";

const ExplanationModal = () => {
  const STATE = useAppStateStore();

  if (!STATE.isExplanationModal) return null;

  const closeExplanationModal = () => {
    STATE.setIsExplanationModal(false);
  };

  const policyDetailsString = localStorage.getItem("policyDetails");
  const policyDetails = policyDetailsString
    ? JSON.parse(policyDetailsString)
    : null;

  const features = policyDetails.uberpolicies ?? [];

  // Find the first matching feature for the current modal heading
  const matchingFeature = features?.AllSchemeFeatureDescriptions?.find(
    (feature) => feature?.featureName === STATE.modalHeading
  );

  return (
    <>
      {STATE.currentStep === QuoteStep.TQ_PANEL && STATE.isExplanationModal && (
        <>
          <div
            className="transparentBgFixed"
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                closeExplanationModal();
              }
            }}
          ></div>
          <div className="ExplanationModelMainBody appear-1023">
            <div id="myModal" className="modal">
              <div className="explanation-modal-content explanationModelScroll">
                <div className="info-modal-header">
                  {STATE.modalHeading === "Additional Excesses" ? (
                    <h1>Excess</h1>
                  ) : (
                    <h1>{STATE.modalHeading}</h1>
                  )}
                  <span onClick={closeExplanationModal} className="info-close">
                    &times;
                  </span>
                </div>
                <div className="explanation-modal-body container">
                  {matchingFeature?.schemeFeatureDefinition ? (
                    <div>
                      <p className="font-14">
                        {matchingFeature.schemeFeatureDefinition}
                      </p>

                      {/* Map through schemeDescriptions */}
                      {Object.entries(
                        matchingFeature.schemeDescriptions ?? {}
                      ).map(([sectionTitle, descriptions], index) => (
                        <div key={index}>
                          <div className="border-bottom padding-x-5">
                            <p className="font-bold font-14">{sectionTitle}</p>
                          </div>
                          {descriptions?.map((desc, i) => {
                            // Handle descriptions with "##-##" separator
                            if (desc?.includes("##-##")) {
                              const [part1, part2] = desc.split("##-##");
                              return (
                                <div
                                  key={i}
                                  className="border-bottom"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  <p className="padding-x-5 font-weight-400 font-14">
                                    {part1?.trim()}
                                  </p>
                                  <p
                                    className="padding-x-5 font-weight-400 font-14"
                                    style={{ minWidth: "51px" }}
                                  >
                                    {part2?.trim()}
                                  </p>
                                </div>
                              );
                            }
                            // Regular description without separator
                            return (
                              <div key={i} className="border-bottom">
                                <p className="padding-x-5 font-weight-400 font-14">
                                  {desc}
                                </p>
                              </div>
                            );
                          })}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p>No information available for this feature.</p>
                  )}
                </div>
                <div className="modal-footer"></div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ExplanationModal;
